<template>
    <header>
        <div class="content">
            <div class="navbar-toggler-icon" @click="toggleMenu()"></div>
            <router-link :to="'/'" @click="setActive()" class="logo" tag="div"></router-link>
            <div class="right-block">
                <nav class="main inline-block vertical-align-middle">
                    <router-link :to="route.path" class="nav-btn" v-for="(route, routeKey) in $store.state.menu.routes" v-bind:class="route.subs ? 'subs' : ''" :key="'route-' + routeKey">
                        <span>{{ route.name }}</span>
                    </router-link>
                </nav>
                <div class="callback inline-block">
                    <span class="phone">{{ $store.state.data.phone }}</span>
                    <span class="desc">{{ phone_desc }}</span>
                    <a :href="'tel:' + $store.state.data.phone" class="mobile-phone"></a>
                </div>
            </div>
        </div>
        <mobile-menu
                v-if="mobileMenu.showModal"
                @close="mobileMenu.showModal = false">
        </mobile-menu>
    </header>
</template>

<script>
    import Modal from './Modal.vue'
    import MobileMenu from './elements/MobileMenu.vue'


    export default {
        data() {
            return {
                phone: '8 800 3500 868',
                phone_desc: 'Бесплатные консультации',
                mobileMenu: {
                    showModal: false,
                    width: '100%',
                    height: 'calc(100% - 45px)',
                    header: '<div class="mobile-menu-logo"></div>',
                    body: '',
                    buttonText: '',
                    buttonClass: 'big white no-float'
                }
            }
        },
        methods: {
            setActive: function () {
                this.$store.state.mutations.setRouteActive()
            },
            toggleMenu: function () {
                this.mobileMenu.showModal = !this.mobileMenu.showModal
            }
        },
        components: {
            Modal, MobileMenu
        },
        mounted(){
            let res = [];
            this.$store.state.menu.routes.forEach(function (item) {
                res.push('<div class="mobile-menu-item"><a href="#' + item.path + '/">' + item.name + '</a></div>')
            });

            this.mobileMenu.body = res.join('')
        }
    }
</script>

<style scoped>
    header {
        border-bottom: solid 1px rgba(255, 255, 255, 0.08);
        height: 81px;
        background-image: linear-gradient(to right, #003873, #004a87, #005d9a, #0070ad, #0284c0);
        white-space: nowrap;
    }

    .logo {
        cursor: pointer;
    }

    header a {
        color: #FFFFFF;
    }
    .content{
        display: flex;
        justify-content: space-between;
        height: 100%;
    }
    .content >.right-block{
        display: flex;
        justify-content: space-between;
        height: 100%;
    }
    nav{
        display: flex;
        height: 100%;
    }
    nav >.nav-btn{
        height: 100%;
        display: flex;
    }
    
    nav >.nav-btn:first-child{
        margin-left: 0px;
    }
    nav >.nav-btn:last-child{
        margin-right: 0px;
    }
    nav >.nav-btn >span{
        margin: auto;
        margin: auto 13px auto 13px;
    }
</style>


// WEBPACK FOOTER //
// src/views/Header.vue